// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-modal {
  --width: 400px !important;
  --height: 300px !important;
  --border-radius: 0;
  --box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  align-self: flex-end;
  margin-top: 70px;
  margin-right: 10px;
}

ion-list.popover-list {
  padding: 0;
  margin: 0;
}

.pop-item {
  padding: 8px;
  min-height: 50px;
  background: rgb(0, 0, 0.5);
  align-items: center;
  cursor: pointer;
  display: flex;
}
.pop-item ion-icon {
  color: white !important;
  margin-right: 12px;
  font-size: 20px;
  margin-top: 7px;
  margin-left: 5px;
}
.pop-item ion-label {
  color: white !important;
  margin-top: 10px;
  font-size: 15px;
}
.pop-item .app-version {
  float: right;
  font-size: 10px;
  padding-top: 3px;
  color: #acaaaa;
  margin-left: auto;
}

ion-label {
  display: flex;
  justify-content: space-between;
}

.log-version {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

@media (max-width: 768px) {
  .profile-modal {
    --width: 180px;
    margin-right: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/charter/charter-ui/charter-nav/nav-popover/nav-popover.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,2CAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AACF;AACE;EACE,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;AAAJ;AAEE;EACC,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAAH;;AAGA;EACE,aAAA;EACA,8BAAA;AAAF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AACF;;AAEA;EACE;IACE,cAAA;IACA,iBAAA;EACF;AACF","sourcesContent":[".profile-modal {\n  --width: 400px !important;\n  --height: 300px !important;\n  --border-radius: 0;\n  --box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n  align-self: flex-end;\n  margin-top: 70px;\n  margin-right: 10px;\n}\n\nion-list.popover-list {\n  padding: 0;\n  margin: 0;\n}\n\n.pop-item {\n  padding: 8px;\n  min-height: 50px;\n  background: rgb(0, 0, 0.5);\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n\n  ion-icon {\n    color: white !important;\n    margin-right: 12px;\n    font-size: 20px;\n    margin-top: 7px;\n    margin-left: 5px;\n  }\n\n  ion-label {\n    color: white !important;\n    margin-top: 10px;\n    font-size: 15px;\n  }\n  .app-version {\n   float: right;\n   font-size: 10px;\n   padding-top: 3px;\n   color: #acaaaa;\n   margin-left: auto;\n  }\n}\nion-label {\n  display: flex;\n  justify-content: space-between;\n}\n.log-version {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n}\n@media (max-width: 768px) {\n  .profile-modal {\n    --width: 180px;\n    margin-right: 5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
